import { render, staticRenderFns } from "./DashBlock.vue?vue&type=template&id=51370b52&"
import script from "./DashBlock.vue?vue&type=script&lang=js&"
export * from "./DashBlock.vue?vue&type=script&lang=js&"
import style0 from "./DashBlock.vue?vue&type=style&index=0&id=51370b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports